import { parseJSONWithDefault } from "../../../utils";
const AUTH_LOCAL_STORAGE_KEY = "__session-replay-user-research-authorisation";
const NUM_SESSION_RECORDED_STORAGE_KEY = "__session-replay-recorded-sessions";
var USER_RESEARCH_AUTHORISATION_STATUS = /* @__PURE__ */ ((USER_RESEARCH_AUTHORISATION_STATUS2) => {
  USER_RESEARCH_AUTHORISATION_STATUS2["AUTHORISED"] = "authorised";
  USER_RESEARCH_AUTHORISATION_STATUS2["NOT_AUTHORISED"] = "not-authorised";
  USER_RESEARCH_AUTHORISATION_STATUS2["PENDING_AUTHORISATION"] = "pending-authorisation";
  return USER_RESEARCH_AUTHORISATION_STATUS2;
})(USER_RESEARCH_AUTHORISATION_STATUS || {});
const shouldRecordPath = (bPoint, experiments) => {
  var _a;
  if (hasMetMaxNumOfRecordings(experiments)) {
    return false;
  }
  const pathsToRecord = (_a = experiments == null ? void 0 : experiments.map((experiment) => experiment.enablesPages).flat()) != null ? _a : [];
  if (pathsToRecord == null ? void 0 : pathsToRecord.includes(bPoint)) {
    return true;
  }
  if (pathsToRecord == null ? void 0 : pathsToRecord.includes("*")) {
    return true;
  }
  return false;
};
const isUserAuthorisedToRecord = (experiments, uid) => {
  const isSellerAuthorisedToRecord = window.localStorage.getItem(`${AUTH_LOCAL_STORAGE_KEY}-${uid}`);
  if (isSellerAuthorisedToRecord === "true") {
    return "authorised" /* AUTHORISED */;
  } else if (isSellerAuthorisedToRecord === "false") {
    return "not-authorised" /* NOT_AUTHORISED */;
  } else {
    return "pending-authorisation" /* PENDING_AUTHORISATION */;
  }
};
const hasMetMaxNumOfRecordings = (experiments) => {
  var _a, _b, _c;
  const maxToRecord = (_b = (_a = experiments == null ? void 0 : experiments[0]) == null ? void 0 : _a.maxPerDay) != null ? _b : 10;
  const currDate = /* @__PURE__ */ new Date();
  const currDateString = `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`;
  const numSessionsRecordedString = (_c = window.localStorage.getItem(`${NUM_SESSION_RECORDED_STORAGE_KEY}`)) != null ? _c : "";
  const numSessionsRecordedConfig = parseJSONWithDefault(numSessionsRecordedString, {
    date: currDateString,
    numSessionsRecordedToday: 0
  });
  if ((numSessionsRecordedConfig == null ? void 0 : numSessionsRecordedConfig.date) === currDateString && (numSessionsRecordedConfig == null ? void 0 : numSessionsRecordedConfig.numSessionsRecordedToday) >= maxToRecord) {
    return true;
  }
  return false;
};
const incrementNumOfSessionsRecordedToday = () => {
  var _a;
  const currDate = /* @__PURE__ */ new Date();
  const currDateString = `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`;
  const numSessionsRecordedString = (_a = window.localStorage.getItem(`${NUM_SESSION_RECORDED_STORAGE_KEY}`)) != null ? _a : "";
  const numSessionsRecordedConfig = parseJSONWithDefault(numSessionsRecordedString, {
    date: currDateString,
    numSessionsRecordedToday: 0
  });
  let newNumSessionsRecordedConfig;
  if (numSessionsRecordedConfig.date === currDateString) {
    newNumSessionsRecordedConfig = {
      date: currDateString,
      numSessionsRecordedToday: numSessionsRecordedConfig.numSessionsRecordedToday += 1
    };
  } else {
    newNumSessionsRecordedConfig = {
      date: currDateString,
      numSessionsRecordedToday: 1
    };
  }
  window.localStorage.setItem(
    `${NUM_SESSION_RECORDED_STORAGE_KEY}`,
    JSON.stringify(newNumSessionsRecordedConfig)
  );
  return;
};
const setLocalStorageAuthorisationToRecord = (authorisation, sellerId) => {
  window.localStorage.setItem(`${AUTH_LOCAL_STORAGE_KEY}-${sellerId}`, authorisation.toString());
};
export {
  AUTH_LOCAL_STORAGE_KEY,
  NUM_SESSION_RECORDED_STORAGE_KEY,
  USER_RESEARCH_AUTHORISATION_STATUS,
  hasMetMaxNumOfRecordings,
  incrementNumOfSessionsRecordedToday,
  isUserAuthorisedToRecord,
  setLocalStorageAuthorisationToRecord,
  shouldRecordPath
};
